export default [
  {
    label: 'No Payment Method on File',
    description: `To keep your program active and compliant with the terms of the 
    contract, you must have an active payment method in place, either ACH or Credit Card.`,
    value: '',
  },
  {
    label: 'Pending',
    description: `Your payment is currently pending and requires additional verification. 
    We appreciate your patience while we complete the necessary checks.`,
    value: 'requires_action',
  },
  {
    label: 'Verified',
    description: `Congratulations! Your payment method is verified and securely on file. 
    You can proceed with confidence knowing that your preferred payment 
    option is set up and ready to go.`,
    value: 'succeeded',
  },
  {
    label: 'Error',
    description: `Oops! We encountered a general error while processing your payment. 
    Please reach out to our friendly admin team, and we'll be happy to assist you 
    in resolving the issue promptly.`,
    value: 'other',
  },
];
